import React from 'react'
import MemberLeft from './member-left'
import MemberRight from './member-right'
import leftinfos from "../Datas/members-left.json"
import Member from './Member'

const MemberBox = () => {
  return (
    <>
    <div className='member-box'>
        {leftinfos.map((leftinfo,index)=><Member
        leftinfo = {leftinfo}
        key={index}
        />)}
      </div>
    </>
        

  )
}

export default MemberBox